import React from "react";
import {
  Edit,
  Eye,
  Trash2,
  Plus,
  Search,
  X,
  Check,
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  ChevronRight,
  Download,
  Upload,
  FileText,
  User,
  Settings,
  LogOut,
  Bell,
  Home,
  ArrowLeft,
  ArrowRight,
  Info,
  AlertCircle,
  CheckCircle,
  LayoutDashboard,
  FilePlus,
  List,
  Users,
  Building2,
  Clock,
} from "lucide-react";
import "./index.scss";

const ICON_MAP = {
  // ── Sidebar icons ────────────────────────────────────────────────────────
  dashboard: LayoutDashboard,
  createNew: FilePlus,
  list: List,
  groupIcon: Users,
  company: Building2,
  tatHistory: Clock,

  // ── Action icons ─────────────────────────────────────────────────────────
  edit: Edit,
  view: Eye,
  delete: Trash2,
  plus: Plus,
  search: Search,
  close: X,
  check: Check,
  "chevron-down": ChevronDown,
  "chevron-up": ChevronUp,
  "chevron-left": ChevronLeft,
  "chevron-right": ChevronRight,
  download: Download,
  upload: Upload,
  file: FileText,
  user: User,
  settings: Settings,
  logout: LogOut,
  bell: Bell,
  home: Home,
  "arrow-left": ArrowLeft,
  "arrow-right": ArrowRight,
  info: Info,
  alert: AlertCircle,
  success: CheckCircle,
};

const Icon = ({
  iconName,
  onClick,
  height = 19,
  width = 19,
  color,
  marginLeft,
  marginRight,
  className = "",
  title,
  disabled = false,
}) => {
  const LucideIcon = ICON_MAP[iconName];

  if (!LucideIcon) {
    console.warn(`[Icon] Unknown iconName: "${iconName}"`);
    return null;
  }

  const style = {
    ...(color && { color }),
    ...(marginLeft && { marginLeft }),
    ...(marginRight && { marginRight }),
  };

  const handleClick = (e) => {
    if (disabled || !onClick) return;
    onClick(e);
  };

  return (
    <span
      className={[
        "icon-wrapper",
        onClick && !disabled ? "icon-clickable" : "",
        disabled ? "icon-disabled" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      onClick={handleClick}
      style={style}
      title={title || iconName}
      role={onClick ? "button" : undefined}
      tabIndex={onClick && !disabled ? 0 : undefined}
      onKeyDown={
        onClick && !disabled
          ? (e) => e.key === "Enter" && onClick(e)
          : undefined
      }
      aria-label={title || iconName}
    >
      <LucideIcon size={Math.max(height, width)} />
    </span>
  );
};

export default Icon;
